import configuration from "./index";

export const ComponentAPI = {
  getGroups: async () => {
    const url = configuration.apiBase + "/library/statuspage/groups";
    const response = await fetch(url).then((res) => res.json());
    return response.groups;
  },

  getComponents: async (groupID) => {
    const url =
      configuration.apiBase + `/library/statuspage/group/${groupID}/components`;
    const response = await fetch(url).then((res) => res.json());
    return response.components;
  },
};
